import { Injectable } from '@angular/core';
import { SessionStorageKeys, SessionStorageService } from './session-storage.service';
import { LocalStorageService, LocalStorageKeys } from './local-storage.service';

@Injectable({ providedIn: 'root' })
export class PrivacyConsentStorageService {

    constructor(private localStorageService: LocalStorageService) { }

    isAccepted(): boolean {
        return this.localStorageService.getStr(LocalStorageKeys.PrivacyConsent) === 'true';
    }

    saveAccepted(): void {
        this.localStorageService.setStr(LocalStorageKeys.PrivacyConsent, 'true');
    }

    clear(): void {
        this.localStorageService.removeItem(LocalStorageKeys.PrivacyConsent);
    }
}
